import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import Badge from 'src/components/badges/badge';
const isServer = typeof window === 'undefined';

import config from 'config/config';
import {trackFootfallEvent} from 'src/utils/analytics';
import footfallEventTypes from 'src/constants/footfallEventTypes';

// Sitebar subcomponents
import SearchLink from 'src/components/siteBar/searchLink';
import VisitorMenu from './visitorMenu';
import UserMenu from './userMenu';
import HubMenu from './hubMenu';
import NotificationMenu from './notificationMenu';
import SearchInput from 'src/components/inputs/search';
import Button from 'src/components/buttons/button';

// Mobile navigation bar
import MobileNavbar from './mobileNavBar';

import i18n from 'i18next';
import signupContext from 'src/constants/signupContext';

import { fetchNotifications } from 'src/modules/shared/context/actions';
import { logout } from 'src/modules/shared/auth/actions';
import { showSignupModal, showLoginModal } from 'src/modules/shared/modal/actions';
import * as log from 'loglevel';

const initialMenuState = {
  openUserMenu: false,
  openHubMenu: false,
  openNotifications: false,
  openVisitorMenu: false,
};

const basicClasses = {
  'sitebar-container': true,
  'sitebar-container--centered-mobile': true,
};
const visitorSitebarClassNames = classNames({
  'hidden-xs': false,
  'sitebar-container--centered': true,
  ...basicClasses,
});
const homeSitebarClassNames = classNames({
  'sitebar-container': true,
  'sitebar-container--home': true,
});
const memberSitebarClassNames = classNames({
  'hidden-xs': true,
  ...basicClasses,
});

const getCurrentRoute = () => {
  if (isServer) return null;
  return window.location.pathname.split('?')[0];
};

class SiteBar extends React.Component {

  static propTypes = {
    community: PropTypes.object.isRequired,
    selectedPage: PropTypes.string,
    user: PropTypes.object,
  }

  static defaultProps = {
    basic: false,
    community: {},
    fetchNotifications: () => {},
    unreadNotifications: 0,
    user: {},
  }

  constructor(props) {
    super(props);
    this.state = {
      ...initialMenuState,
    };
    if (!config.isServer) {
      i18n.on('loaded', () => {
        // it's truly horrible we have to do this, but raymond _made_ me do it
        // otherwise the sitebar won't update when new translations are loaded
        log.info('new language loaded; forcing update of sitebar');
        this.forceUpdate();
      });
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setMenuWrapperRef = (node) => {
    this.menuWrapperRef = node;
  }

  handleClickOutside = (event) => {
    if (this.menuWrapperRef && !this.menuWrapperRef.contains(event.target)) {
      this.setState(initialMenuState);
    }
  }

  toggleMenuHideOthers = (event, menuToToggle) => {
    if (event) event.preventDefault();
    const stateObj = { ...initialMenuState };
    if (menuToToggle) stateObj[menuToToggle] = !this.state[menuToToggle];
    this.setState(stateObj);
    if (event) event.stopPropagation();
  }

  onNotificationsClick = (event) => {
    if (!this.state.openNotifications) {
      this.props.fetchNotifications(this.props.t);
    }
    this.toggleMenuHideOthers(event, 'openNotifications');
  }

  renderMemberSitebar() {
    const { community, lang, pageType,
      unreadNotificationsCount, unreadMessagesCount, currentUser: user, logout, notifications } = this.props;
    const communityId = community && community.communityId;
    const name = community && community.name;
    const followedCommunities = user.followedCommunities;
    const searchPlaceholder = pageType === 'community'
      ? `${i18n.t('Search')} ${name || ''}`
      : i18n.t('Search HealthUnlocked');
    const currentRoute = getCurrentRoute();
    const homeClasses = classNames({
      'site-bar__heading': true,
      'site-bar__heading__active': currentRoute === '',
    });
    const messagesClasses = classNames({
      'site-bar__heading': true,
      'site-bar__heading__active': currentRoute === 'messages',
    });
    return (
      <div className="sitebar">
        <MobileNavbar
          currentUser={user}
          unreadMessages={unreadMessagesCount}
          unreadNotifications={unreadNotificationsCount}
        />
        <div className={memberSitebarClassNames} ref={this.setMenuWrapperRef}>
          <div className="sitebar-actions-left">
            <a href="/" className={homeClasses} onClick={() =>
              trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: {section: 'home'}, clickType: 'member-sitebar' })
            }>
              <span className="icon-home-clear" style={{marginRight: '5px'}}/>
              <span className="hidden-sm">
                {i18n.t('Home')}
              </span>
            </a>
            <HubMenu
              open={this.state.openHubMenu}
              handleClick={event => {
                event.preventDefault();
                trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: {section: 'hub-menu'}, clickType: 'member-sitebar' });
                this.toggleMenuHideOthers(event, 'openHubMenu');
              }}
              followedCommunities={followedCommunities}
              userId={user.userId}
            />
            <a href="/messages" className={messagesClasses} onClick={() =>
              trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: {section: 'messages'}, clickType: 'member-sitebar' })
            }>
              <span className="icon-messages" style={{marginRight: '5px'}}/>
              <span className="hidden-sm">{i18n.t('Chat')}{' '}</span>
              {unreadMessagesCount > 0 && <Badge content={unreadMessagesCount} type="new" />}
            </a>
            <NotificationMenu
              notifications={notifications}
              unreadNotifications={unreadNotificationsCount}
              open={this.state.openNotifications}
              handleClick={event => {
                trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: {section: 'notification-menu'}, clickType: 'member-sitebar' });
                this.onNotificationsClick(event);
              }}
            />
          </div>
          <div className={'site-logo site-logo--centered'}>
            <a
              href="/"
              onClick={() =>
                trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: {section: 'hu-logo'}, clickType: 'member-sitebar' })
              }
            >
              <img alt="HealthUnlocked" src={`${config.cdn.static}img/healthunlocked-logo-green.png`} height="16" width="172"/>
            </a>
          </div>
          <div className="sitebar-actions-right">
            <SearchLink
              url={communityId ? `/search/posts?page=1&community=${communityId}` : '/search/posts'}
            />
            <SearchInput
              className="sitebar-search sitebarform sitebar-action hidden-sm pull-left"
              groupCode={communityId}
              placeholder={searchPlaceholder}
              handleClick={() =>
                trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: {section: 'search-bar'}, clickType: 'member-sitebar' })
              }
            />
            <UserMenu
              open={this.state.openUserMenu}
              handleClick={event => {
                trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: {section: 'profile-menu'}, clickType: 'member-sitebar' });
                this.toggleMenuHideOthers(event, 'openUserMenu');
              }}
              user={user}
              lang={lang}
              logout={logout}
            />
          </div>
        </div>
      </div>
    );
  }

  renderVisitorSitebar = () => {
    const { community } = this.props;
    return (
      <div className="sitebar">
        <div className={visitorSitebarClassNames}>
          <div ref={this.setMenuWrapperRef}>
            <VisitorMenu
              community={community}
              open={this.state.openVisitorMenu}
              handleClick={event => {
                trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: {section: 'visitor-menu'}, clickType: 'visitor-sitebar' });
                this.toggleMenuHideOthers(event, 'openVisitorMenu');
              }}
            />
          </div>
          <div className={'site-logo site-logo--centered'}>
            <a
              href="/"
              onClick={() =>
                trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: {section: 'hu-logo'}, clickType: 'visitor-sitebar' })
              }
            >
              <img alt="HealthUnlocked" src={`${config.cdn.static}img/healthunlocked-logo-green.png`} height="16" width="172"/>
            </a>
          </div>
          <div className="sitebar-actions-right">
            <a
              href="/login"
              className="hidden-xs sitebar-action"
              id="sitebar-login-button"
              onClick={event =>{
                event.preventDefault();
                this.props.showLoginModal();}}
              key="login"
            >
              {i18n.t('Log in')}
            </a>
            <Button
              className="sitebar-action sitebar-signup"
              id="sitebar-signup-button"
              onClick={() =>{
                this.props.showSignupModal({
                  section: signupContext.section.HEADER,
                  element: signupContext.element.SIGNUP,
                }, community);}
              }
              key="signup"
              text={i18n.t('Join')}
            />
          </div>
        </div>
      </div>
    );
  }

  renderHomeSitebar = () => {
    const { community } = this.props;
    return (
      <div className="sitebar">
        <div className={homeSitebarClassNames}>
          <div className="sitebar-actions-left hidden-xs">
            <a
              className="sitebar-action"
              href="/about"
              onClick={() =>
                trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: {section: 'about-us'}, clickType: 'visitor-sitebar' })
              }
            >
              {i18n.t('About us')}
            </a>
            {'   '}
            <a
              className="sitebar-action"
              href="/start"
              onClick={() =>
                trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: {section: 'start'}, clickType: 'visitor-sitebar' })
              }
            >
              {i18n.t('Start a community')}
            </a>
          </div>
          <div className={'site-logo site-logo--home'}>
            <a
              href="/"
              onClick={() =>
                trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: {section: 'hu-logo'}, clickType: 'visitor-sitebar' })
              }
            >
              <img alt="HealthUnlocked" src={`${config.cdn.static}img/healthunlocked-logo-green.png`} height="16" width="172"/>
            </a>
          </div>
          <div className="sitebar-actions-right">
            <a
              href="/login"
              className="hidden-xs sitebar-action"
              id="sitebar-login-button"
              onClick={event =>{
                event.preventDefault();
                trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: {section: 'login'}, clickType: 'visitor-sitebar' });
                this.props.showLoginModal();}}
              key="login"
            >
              {i18n.t('Log in')}
            </a>
            <Button
              className="sitebar-action sitebar-signup"
              id="sitebar-signup-button"
              onClick={() =>{
                trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: {section: 'join'}, clickType: 'visitor-sitebar' });
                this.props.showSignupModal({
                  section: signupContext.section.HEADER,
                  element: signupContext.element.SIGNUP,
                }, community);}
              }
              key="signup"
              text={i18n.t('Join')}
            />
          </div>
        </div>
      </div>
    );
  }

  renderBasicSitebar = () => {
    const { lang } = this.props;
    return (
      <div className="sitebar">
        <div className={'site-logo site-logo--centered'} ref={this.setMenuWrapperRef}>
          <a
          >
            <img src={`${config.cdn.static}img/healthunlocked-logo-green.png`} height="16" width="172"/>
          </a>
          <div className="sitebar-actions-right">
            <a
              className="sitebar-link hidden-xs"
              href={config.community[lang].support}
              target="_blank">
              {i18n.t('Help')}
            </a>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { isLoggedIn, basic, isHome } = this.props;

    if (basic) {
      return this.renderBasicSitebar();
    } else if (isHome && !isLoggedIn) {
      return this.renderHomeSitebar();
    } else if (isLoggedIn) {
      return this.renderMemberSitebar();
    } else {
      return this.renderVisitorSitebar();
    }
  }
}

const mapStateToProps = (state) => {
  return {
    isLoggedIn: !!state.context.currentUser,
    currentUser: state.context.currentUser,
    unreadNotificationsCount: state.context.unreadNotificationsCount,
    unreadMessagesCount: state.context.unreadMessagesCount,
    unreadCount: state.context.unreadNotificationsCount + state.context.unreadMessagesCount,
    notifications: state.context.notifications,
  };
};

export default connect(mapStateToProps, { logout, fetchNotifications, showLoginModal, showSignupModal })(SiteBar);



// WEBPACK FOOTER //
// ./src/components/siteBar/siteBar.js